import { render, staticRenderFns } from "./RoundCheckbox.vue?vue&type=template&id=8906d002&scoped=true"
import script from "./RoundCheckbox.vue?vue&type=script&lang=js"
export * from "./RoundCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RoundCheckbox.vue?vue&type=style&index=0&id=8906d002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8906d002",
  null
  
)

export default component.exports